import { dcrControlStyles } from '../DcrControl/DcrControl.styles';

export const profileReactivateControlStyles = {
	button: {
		...dcrControlStyles.button,
		textTransform: 'uppercase'
	}
};
